import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import DescriptionIcon from "@mui/icons-material/Description";
import { investorApi } from "../api/api";
import YourPropertyImgs from "../components/YourProperty/YourPropertyImgs";
import YourPropertyDocuments from "../components/YourProperty/YourPropertyDocuments";
// import YourPropertyDetails from "../components/YourProperty/YourPropertyDetails";
import CollectionsIcon from "@mui/icons-material/Collections";
import Loader from "../components/common/Loader";

const YourPropertyScreen = () => {
  const userId = useSelector((state) => state.user.userId);
  const { state } = useLocation();
  const properties = state?.property;
    const theme = useSelector((data) => data.themeValue.colors);
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchDetails = async () => {
      try {
        const response = await investorApi.getPropertyDetails(properties.id);
        if (response.status === 200) {
          setPropertyData(response.data);
        }
      } catch (error) {
        console.error("API Error", error);
      } finally {
        setLoading(false);
      }
    };

    if (properties?.id) {
      fetchDetails();
    } else {
      setLoading(false);
    }
  }, [properties?.id]);
  const layoutConfig = [
    {
      id: "PropertyImages",
      render: () => <YourPropertyImgs data={propertyData} />,
    },
    //   {
    //   id: "PropertyDetails",
    //   render: () => <YourPropertyDocuments  data={propertyData} />,
    // },
    // {
    //   id: "PropertyDetails",
    //   render: () => <YourPropertyDetails data={propertyData} />,
    // },
  ];

  const handlePriceUpdate = () => {
    navigate("/priceupdate", { state: { propertyData: propertyData } });
  };

  const handleAddDocuments = () => {
    navigate("/addDocuments",{state:{propertyData:propertyData}});
  };

  const handleEditProperty = () => {
    navigate("/editproperty", { state: { propertyData: propertyData } });
  };
  const handleAddMultipleImages = () => {
    navigate("/AddImages", { state: { propertyData: propertyData } });
  };
  const actions = [
    {
      icon: <PriceChangeIcon />,
      name: "Price Update",
      onClick: handlePriceUpdate,
    },
    {
      icon: <DescriptionIcon />,
      name: "Add Documents",
      onClick: handleAddDocuments,
    },
    {
      icon: <EditIcon />,
      name: "Edit Property",
      onClick: handleEditProperty,
    },
    {
      icon: <CollectionsIcon />,
      name: "Add Multiple Images",
      onClick: handleAddMultipleImages,
    },
  ];

  return (
    <div style={styles.container}>
      { loading ? (
        <Loader/>
      ) :
      !properties ? (
        <p>No properties available</p>
      ) : (
        <div style={styles.sectionWrapper}>
          {layoutConfig.map((layout) => (
            <div key={layout.id} style={ {...styles.section }}>
              {layout.render()}
            </div>
          ))}
        </div>
      )}

      {/* SpeedDial FAB */}
      <SpeedDial
        ariaLabel="Property actions"
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
          />
        ))}
      </SpeedDial>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    // backgroundColor: "#f5f7fa",
    minHeight: "100vh",
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
   
  },
  section: {
    padding: "10px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
};

export default YourPropertyScreen;